<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'top' ,
                    params: { brandPath: $route.params.brandPath}} ">TOPへ</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s"></p>
                    <p class="menu_center_tex_l">報告書コメントアラート</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <ReportCommentAlertList />
    </div>
</template>

<script>
    // @ is an alias to /src
    import ReportCommentAlertList from '@/app/components/ReportCommentAlertList.vue'

    export default {
        name: 'reportCommentAlertListIndex',
        components: {
          ReportCommentAlertList
        },
        props: {
            menuId: Number,
        }
    }
</script>
